<template>
  <div class="params">
    <page-search
      ref="pageSearchRef"
      :searchFormConfig="searchFormConfig"
      :pageTitle="$t('param.param-list')"
      @resetBtnClick="handleResetClick"
      @queryBtnClick="handleQueryClick"
    >
    </page-search>
    <page-content
      style="margin-top: 10px"
      ref="pageContentRef"
      v-bind="tableOptionsConfig"
      @newBtnClick="handleNewData"
      @editBtnClick="handleEditData"
      @viewBtnClick="handleViewData"
      @importBtnClick="handleImport"
      @pageInfoChange="pageInfoChangeAction"
    >
      <template #otherHandler="scope">
        <el-button
          v-if="isSwitch && isNormalStatus(scope.row.status)"
          class="opt-btn"
          icon="el-icon-lock"
          size="mini"
          plain
          type="warning"
          @click="handleDisableClick(scope.row)"
          >{{ $t('general.disable') }}</el-button
        >
        <el-button
          v-if="isSwitch && !isNormalStatus(scope.row.status)"
          class="opt-btn"
          icon="el-icon-unlock"
          size="mini"
          plain
          @click="handleEnableClick(scope.row)"
          >{{ $t('general.enable') }}</el-button
        >
      </template>
    </page-content>
  </div>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue'

import pageSearch from '@/components/PageSearch/page-search'
import pageContent from '@/components/PageContent/page-content.vue'

import { searchFormConfig } from './config/param.form'
import { contentTableConfig } from './config/param.table'
import { useRouter } from 'vue-router'
import { usePermission } from '@/hooks/use-permission'

// 表格基础配置项
const tableOptions = {
  moduleName: 'parameter', // 所属的模块
  pageName: 'parameter', // 所属的页面
  contentTableConfig,
  isShowDeleteSlot: true,
  isShowImportSlot: true,
  pageAction: 'param/getParamListData', // 获取表格的Action
  deleteRecordAction: 'param/handleDeleteParam',
  deleteSelectionAction: 'param/deleteMultiParam', // 删除record的Action
  pageCountGetter: 'param/pageListCount', // 获取表格记录数据总和getters
  pageListGetter: 'param/pageListData' // 获取表格列表数据getters
}

const tableOptionsConfig = computed(() => tableOptions)

const pageContentRef = ref('')
const pageSearchRef = ref('')

const isSwitch = usePermission(
  tableOptions.moduleName,
  tableOptions.pageName,
  'switch'
)

const handleQueryClick = (queryInfo) => {
  pageContentRef.value.getPageData(queryInfo)
}

const handleResetClick = () => {
  pageContentRef.value.getPageData()
}
const router = useRouter()

const handleEditData = (id) => {
  router.push(`/param/edit/${id}`)
}

const handleViewData = (id) => {
  router.push(`/param/view/${id}`)
}
const handleImport = () => {
  router.push(`/param/new/import`)
}

const handleNewData = () => {
  router.push(`/param/new`)
}
const pageInfoChangeAction = () => {
  const formData = pageSearchRef.value.getCurrentFieldValues()
  pageContentRef.value.getPageData(formData)
}

const isNormalStatus = (status) => {
  return status === '00'
}
const { appContext } = getCurrentInstance()
const handleMessageCommit =
  appContext.config.globalProperties.$handleMessageCommit
const handleDisableClick = async (row) => {
  handleMessageCommit('param/handleTerminalParamDisableAction', row.id).then(
    () => {
      pageContentRef.value.getPageData()
    }
  )
}
const handleEnableClick = async (row) => {
  handleMessageCommit('param/handleTerminalParamEnableAction', row.id).then(
    () => {
      pageContentRef.value.getPageData()
    }
  )
}
</script>
